import React, { useMemo } from 'react'
import useStyles from './Styles'
import { Grid } from '@material-ui/core'
import { IProps } from './Interface'
import { MenuItem } from 'components'
import { MENU_LIST, MENU_IDS } from 'config/constants/navigation-menu'
import { Location, navigate } from '@reach/router'
import Scrollspy from 'react-scrollspy'
import { orderBy } from 'lodash'
import { useServiceState } from 'helpers'
import ImGoodAtService from 'smart-components/im-good-at/Service'
import UserResponsesManagerService from 'smart-components/user-responses-manager/Service'

const NavBar: React.FC<IProps> = ({
  isLogged,
  showWarningIcons,
  disableMenuItem,
  hideMenuItem,
  currentPath,
  publicMode
}) => {
  const classes = useStyles({ isLogged, publicMode })

  const isSelected = (menu: any) => {
    return false && publicMode ? `#${menu.id}` === window.location.hash : menu.path === currentPath
  }

  const onUpdateScroll = (target: any) => {
    window.history.pushState(null, null, window.location.pathname + '#' + target.id)
  }

  const pages = orderBy(MENU_LIST, menu => menu.id !== MENU_IDS.SNAPSHOT && menu.id !== MENU_IDS.DID_YOU_KNOW)

  const userResponsesManagerState = useServiceState(UserResponsesManagerService, false)
  const questions = useMemo(() => userResponsesManagerState.userResponses?.questions || {}, [
    userResponsesManagerState.userResponses
  ])

  const saveImGoodAt = async () => {
    const isAllValid = ImGoodAtService.validateAllExpertises(questions)

    if (!isAllValid) {
      return
    }

    const expertises = ImGoodAtService.mapStateToExpertise(true)

    await UserResponsesManagerService.updateResponse({
      questionKey: 'expertise',
      response: expertises
    })
  }

  const onMenuChange = (menu: any) => {
    if (!disableMenuItem[menu.id] && !publicMode) {
      if (currentPath === '/im-good-at' && menu.path !== '/im-good-at') {
        saveImGoodAt()
      }
      navigate(menu.path)
    }
  }

  return (
    <Grid container direction="row" className={classes.root}>
      <Grid container direction="column" className={classes.gridContainer}>
        {publicMode ? (
          <Scrollspy
            items={pages.filter(page => !hideMenuItem[page.id]).map(page => page.id)}
            currentClassName={classes.isSelected}
            offset={-300}
            onUpdate={onUpdateScroll}
          >
            {pages.map(
              (menu, i) =>
                !hideMenuItem[menu.id] && (
                  <li
                    key={`nav-bar-menu-${i}`}
                    className={classes.menuItem}
                    onClick={() => (window.location.hash = `#${menu.id}`)}
                  >
                    <a id={`${menu.id}-menu-item-title`} href={`#${menu.id}`} className={classes.menuItemText}>
                      {menu.title}
                    </a>
                  </li>
                )
            )}
          </Scrollspy>
        ) : (
          MENU_LIST.filter(menuItem => menuItem.path).map(
            (menu, i) =>
              !hideMenuItem[menu.id] && (
                <MenuItem
                  id={menu.id}
                  key={`nav-bar-menu-${i}`}
                  href={publicMode && menu.id}
                  onClick={() => onMenuChange(menu)}
                  title={menu.title}
                  isSelected={isSelected(menu)}
                  disabled={disableMenuItem[menu.id]}
                  showWarningIcon={showWarningIcons[menu.id]}
                />
              )
          )
        )}
      </Grid>
    </Grid>
  )
}

NavBar.defaultProps = {
  isLogged: false,
  showWarningIcons: {},
  disableMenuItem: {}
}

export default ({ ...props }) => (
  <Location>{({ location }) => <NavBar currentPath={location.pathname} {...props} />}</Location>
)
